import { useQuery } from "@tanstack/react-query";
import queries from "@/queries";

/**
 * 여러 이메일로 사용자 이름을 일괄 조회하는 훅
 * @param emails - 사용자 이메일 배열
 */
export const useUserNames = (emails: string[]) => {
  const uniqueEmails = [...new Set(emails.filter(Boolean))].sort();

  return useQuery({
    ...queries.userNames(uniqueEmails),
    enabled: uniqueEmails.length > 0,
    gcTime: 15 * 60 * 1000,
    staleTime: 15 * 60 * 1000,
  });
};
